import { defineStore } from 'pinia'
import { LONGITUDE_KEY, LATITUDE_KEY } from '@/config/app.config'
import { safeLocalStorage } from '@/utils/ssr'

interface LocationState {
  longitude: number
  latitude: number
  country: string
  province: string
  city: string
}

export const useLocationStore = defineStore('location', {
  state: (): LocationState => ({
    longitude: Number(safeLocalStorage.getItem(LONGITUDE_KEY) || 0),
    latitude: Number(safeLocalStorage.getItem(LATITUDE_KEY) || 0),
    country: '',
    province: '',
    city: '',
  }),

  actions: {
    setLocation(data: Partial<LocationState>) {
      if (data.longitude !== undefined) {
        this.longitude = data.longitude
        safeLocalStorage.setItem(LONGITUDE_KEY, String(data.longitude))
      }
      if (data.latitude !== undefined) {
        this.latitude = data.latitude
        safeLocalStorage.setItem(LATITUDE_KEY, String(data.latitude))
      }
      if (data.country) this.country = data.country
      if (data.province) this.province = data.province
      if (data.city) this.city = data.city
    },
  },
})
